import { authStorage, iid_AuthService, IAuthService } from "sensei-authentication";
import { IUser } from "csd.phoenix.models/User";
import container from "../../di";

export const getCurrentUserAccountEmail = (): string | undefined =>
  authStorage.getLoginUser<IUser>()?.EmailAddress?.toLowerCase();

// Note: this is the real, DI-bound IAuthService (logout(redirect?), getToken(), etc.) --
// NOT the "sensei-authentication" package's own public useAuthService() hook, whose
// .logout() is only a status dispatcher and takes no redirect callback.
const useAuthService = (): IAuthService => container.get<IAuthService>(iid_AuthService);

export default useAuthService;
